import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid } from "@material-ui/core";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";

export default function Home() {
    return (
        <>
            <DefaultScreenAccordion
                title={"Teste"}
                fields={
                    <GridInputRow>
                        <Grid item xs={12}>
                            <p>Home</p>
                        </Grid>
                    </GridInputRow>}
            />
        </>
    );
};